import { Helpers } from '../../helpers';
import { IProjectCompletionsParameter } from '../../interfaces/iproject-completions-parameter';
import { ArtificialLiftType } from '../artificial-lift-type';
import { CleanoutMethod } from '../cleanout-method';
import { CompletionDesign } from '../completion-design';
import { DesignedRate } from '../designed-rate';
import { DrilloutMethod } from '../drillout-method';
import { FluidSystem } from '../fluid-system';
import { FracFleet } from '../frac-fleet';
import { Project } from '../project';
import { ProjectCompletionsParmetersCompletionDesign } from '../project-completions-parmeters-completion-design';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { ScenarioWell } from '../scenario-well';
import { Well } from '../well';

export class ProjectCompletionsParameterBase {
  ProjectCompletionsParameterId: number;
  DesignedRateId: number | null;
  DrilledLateralLength: number | null;
  ProductionTubingSetTrueVerticalDepth: number | null;
  WellsInFracGroup: number | null;
  WellsInRemoteFracGroup: number | null;
  WellsInDrillGroup: number | null;
  FracFleetId: number | null;
  ScenarioWellId: number | null;
  CompletionDesignId: number | null;
  CleanOutMethodId: number | null;
  DrillOutMethodId: number | null;
  ArtificialLiftTypeId: number | null;
  IsProductionBHPGauges: boolean;
  IsRentalESPPump: boolean;
  DFITTest: boolean;
  Is24HourOperation: boolean;
  IsSimulFracFleet: boolean;
  FluidSystemId: number | null;
  WaterVolumeTotal: number | null;
  WaterVolumeGelWeight: number | null;
  FracWaterVolume: number | null;
  PumpDownWaterVolume: number | null;
  SandQuantity: number | null;
  SandTotal: number | null;
  PumpTime: number | null;
  NumberOfStagesPerDay: number | null;
  LateralFeetCompletePerDay: number | null;
  ProjectDrillingParameterId: number | null;
  WellId: number | null;
  ProjectId: number | null;
  WaterVolumeTotalPct: number | null;
  WaterVolume: number | null;
  SandType1Total: number | null;
  SandType2Total: number | null;
  SandType3Total: number | null;
  SandType4Total: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  CompleteLateralLength: number | null;
  SetUpDays: number | null;
  DrilledLateralLengthDelta: number | null;
  PreStimFracTanks: number | null;

  ProjectCompletionsParmetersCompletionDesigns_ProjectCompletionsParmeter?: Array<ProjectCompletionsParmetersCompletionDesign> | null;
  ArtificialLiftType?: ArtificialLiftType;
  CompletionDesign?: CompletionDesign;
  DesignedRate?: DesignedRate;
  FluidSystem?: FluidSystem;
  FracFleet?: FracFleet;
  ProjectDrillingParameter?: ProjectDrillingParameter;
  Project?: Project;
  ScenarioWell?: ScenarioWell;
  Well?: Well;
  CleanoutMethod?: CleanoutMethod;
  DrilloutMethod?: DrilloutMethod;

  constructor(item?: IProjectCompletionsParameter) {
    if (item) {

      this.ProjectCompletionsParameterId = item.ProjectCompletionsParameterId;
      this.DesignedRateId = item.DesignedRateId;
      this.DrilledLateralLength = item.DrilledLateralLength;
      this.ProductionTubingSetTrueVerticalDepth = item.ProductionTubingSetTrueVerticalDepth;
      this.WellsInFracGroup = item.WellsInFracGroup;
      this.WellsInRemoteFracGroup = item.WellsInRemoteFracGroup;
      this.WellsInDrillGroup = item.WellsInDrillGroup;
      this.FracFleetId = item.FracFleetId;
      this.ScenarioWellId = item.ScenarioWellId;
      this.CompletionDesignId = item.CompletionDesignId;
      this.CleanOutMethodId = item.CleanOutMethodId;
      this.DrillOutMethodId = item.DrillOutMethodId;
      this.ArtificialLiftTypeId = item.ArtificialLiftTypeId;
      this.IsProductionBHPGauges = item.IsProductionBHPGauges;
      this.IsRentalESPPump = item.IsRentalESPPump;
      this.DFITTest = item.DFITTest;
      this.Is24HourOperation = item.Is24HourOperation;
      this.IsSimulFracFleet = item.IsSimulFracFleet;
      this.FluidSystemId = item.FluidSystemId;
      this.WaterVolumeTotal = item.WaterVolumeTotal;
      this.WaterVolumeGelWeight = item.WaterVolumeGelWeight;
      this.FracWaterVolume = item.FracWaterVolume;
      this.PumpDownWaterVolume = item.PumpDownWaterVolume;
      this.SandQuantity = item.SandQuantity;
      this.SandTotal = item.SandTotal;
      this.PumpTime = item.PumpTime;
      this.NumberOfStagesPerDay = item.NumberOfStagesPerDay;
      this.LateralFeetCompletePerDay = item.LateralFeetCompletePerDay;
      this.ProjectDrillingParameterId = item.ProjectDrillingParameterId;
      this.WellId = item.WellId;
      this.ProjectId = item.ProjectId;
      this.WaterVolumeTotalPct = item.WaterVolumeTotalPct;
      this.WaterVolume = item.WaterVolume;
      this.SandType1Total = item.SandType1Total;
      this.SandType2Total = item.SandType2Total;
      this.SandType3Total = item.SandType3Total;
      this.SandType4Total = item.SandType4Total;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.CompleteLateralLength = item.CompleteLateralLength;
      this.SetUpDays = item.SetUpDays;
      this.DrilledLateralLengthDelta = item.DrilledLateralLengthDelta;
      this.PreStimFracTanks = item.PreStimFracTanks;

      this.ProjectCompletionsParmetersCompletionDesigns_ProjectCompletionsParmeter = Helpers.createClassArray(ProjectCompletionsParmetersCompletionDesign, item.ProjectCompletionsParmetersCompletionDesigns_ProjectCompletionsParmeter);
      this.ArtificialLiftType = new ArtificialLiftType(item.ArtificialLiftType);
      this.CompletionDesign = new CompletionDesign(item.CompletionDesign);
      this.DesignedRate = new DesignedRate(item.DesignedRate);
      this.FluidSystem = new FluidSystem(item.FluidSystem);
      this.FracFleet = new FracFleet(item.FracFleet);
      this.ProjectDrillingParameter = new ProjectDrillingParameter(item.ProjectDrillingParameter);
      this.Project = new Project(item.Project);
      this.ScenarioWell = new ScenarioWell(item.ScenarioWell);
      this.Well = new Well(item.Well);
      this.CleanoutMethod = new CleanoutMethod(item.CleanoutMethod);
      this.DrilloutMethod = new DrilloutMethod(item.DrilloutMethod);
    }
  }
}